
// components/EmailPopup.jsx
import React, { useEffect } from "react";

const EmailPopup = ({ onClose }) => {
  useEffect(() => {
    // Close on Escape key
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-2xl font-bold mb-2">We found 1,000+ open positions</h2>
        <p className="mb-6 text-gray-600 text-sm">
          for jobs within 25 miles of your area. To get started, enter your email:
        </p>

        <button className="border w-full py-2 rounded flex items-center justify-center gap-2 text-gray-700 mb-4 hover:bg-gray-50">
          <img src="https://www.svgrepo.com/show/475656/google-color.svg" alt="Google" className="h-5 w-5" />
          Continue with Google
        </button>

        <div className="text-gray-400 text-xs mb-4">OR</div>

        <input
          type="email"
          placeholder="Email"
          className="border w-full px-3 py-2 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-black"
        />
        <button className="w-full bg-black text-white py-2 rounded hover:bg-white hover:text-black transition">
          Continue
        </button>

        <p className="text-xs text-gray-400 mt-4">
          By clicking "Continue", you agree to the Terms of Use and Privacy Policy.
        </p>
      </div>
    </div>
  );
};

export default EmailPopup;
